import { useEffect } from "react";
import { useSelector } from "react-redux";
import AutoRefreshOrganization from "../../../components/SettingModuleComponent/OrganizationPageComponent/AutoRefreshOrganization";
import CreateOrganizationsModal from "../../../components/SettingModuleComponent/OrganizationPageComponent/CreateOrganizationsModal";
import DeleteOrganizationsModal from "../../../components/SettingModuleComponent/OrganizationPageComponent/DeleteOrganizationsModal";
import OrganizationsTableColumn from "../../../components/SettingModuleComponent/OrganizationPageComponent/OrganizationsTableColumn";
import TemplateModal from "../../../components/SettingModuleComponent/OrganizationPageComponent/TemplateModal";
import TableComponent from "../../../components/SharedComponent/TableComponent/TableComponent";
import { closeCreateOrganizationsModal, closeDeleteOrganizationsModal, closeTemplateModal, fetchOrganizations, fetchPaginateOrganizations, openCreateOrganizationsModal, openDeleteOrganizationsModal, openTemplateModal, resetOrganizationsTable, updateOrganizationsRequestBody } from "../../../redux/SettingModule/OrganizationsPage/OrganizationsPageAction";
import { RootState } from "../../../redux/store";
import { useAppDispatch } from "../../../redux/useAppDispatch";

function OrganizationsPage() {
  const dispatch = useAppDispatch();
  const organizationPageState = useSelector((state: RootState) => state.OrganizationsPageState);
  //Modal
  const createOrganizationsModalState = useSelector((state: RootState) => state.OrganizationsPageState.createOrganizationsModalState);
  const deleteOrganizationsModalState = useSelector((state: RootState) => state.OrganizationsPageState.deleteOrganizationsModalState);
  const handleTableSorting = (sorter: any) => {
    const isAscend = (order: string) => {
      if (order === "ascend") {
        return true;
      }

      return false;
    };

    const newSortingRequestBody = {
      ...organizationPageState.currentRequestBody,
      SortColumn: sorter.field,
      IsAsc: isAscend(sorter.order),
    };

    dispatch(resetOrganizationsTable());
    dispatch(updateOrganizationsRequestBody(newSortingRequestBody));
    dispatch(fetchOrganizations({}));
  };

  useEffect(() => {
    dispatch(fetchOrganizations({}));
    return () => {
      dispatch(resetOrganizationsTable());
    };
  }, []);

  return (
    <div className="body-container gap-3">
      <AutoRefreshOrganization />
      <TableComponent
        columns={OrganizationsTableColumn}
        dataSource={organizationPageState.data}
        pagination={organizationPageState.pagination}
        handleTableSorting={handleTableSorting}
        fetchPaginatedData={() => fetchPaginateOrganizations({})}
        loading={organizationPageState.loading}
        tableKey={"Organizations"}
      />

      <CreateOrganizationsModal
        openState={createOrganizationsModalState}
        open={() => dispatch(openCreateOrganizationsModal())}
        close={() => dispatch(closeCreateOrganizationsModal())}
      />
      <TemplateModal
        openState={organizationPageState.templateModalState}
        open={() => dispatch(openTemplateModal())}
        close={() => dispatch(closeTemplateModal())}
      />

      <DeleteOrganizationsModal
        openState={deleteOrganizationsModalState}
        open={() => dispatch(openDeleteOrganizationsModal())}
        close={() => dispatch(closeDeleteOrganizationsModal())}
      />
    </div>
  );
}

export default OrganizationsPage;
